import { useLocaleFormatters } from "$root/localization/hooks";
import { tagColorMap } from "$root/ui-lib/table/colors";
import { TagBadge } from "$root/ui-lib/table/custom-column/tags/Tag";
import type { CustomAttributeDto } from "$root/functional-areas/customAttributes/type";
import type { CustomAttributeValue, Color } from "@eu.mdotm.api/sphere";
import { Row } from "@mdotm/shadcn/legacy/components";
import { identity } from "@mdotm/utils/functions";
import { ForEach } from "@mdotm/utils/react-extra";
import type { ReactNode } from "react";

export function PortfolioCustomAttribute({
	availableAttributes,
	customAttributeRelativeToInvestment,
	textWrapper,
}: {
	availableAttributes: CustomAttributeDto[];
	customAttributeRelativeToInvestment: CustomAttributeValue | undefined;
	textWrapper?: (str: string) => ReactNode;
}) {
	const { formatDate, formatNumber } = useLocaleFormatters();
	if (
		customAttributeRelativeToInvestment?.selectedTags &&
		customAttributeRelativeToInvestment?.selectedTags.length > 0
	) {
		const customAttributeTagsDefinition = availableAttributes.find(
			(customAttribute) => customAttribute.attributeUuid === customAttributeRelativeToInvestment.attributeUuid,
		)?.tags;
		return (
			<Row minSize="0" gap={4} flexGrow={1} className="overflow-hidden">
				<ForEach collection={customAttributeRelativeToInvestment.selectedTags ?? []}>
					{(label) => {
						const matchingColor = customAttributeTagsDefinition?.find((opt) => opt.value === label)?.color;
						return <TagBadge label={label} color={tagColorMap[(matchingColor ?? "GRAY") as Color]?.badgeColor()} />;
					}}
				</ForEach>
			</Row>
		);
	} else {
		return (textWrapper ?? identity)(
			(customAttributeRelativeToInvestment &&
				(customAttributeRelativeToInvestment.selectedTags?.join(", ") ||
					(customAttributeRelativeToInvestment.numberValue != null &&
						formatNumber(customAttributeRelativeToInvestment.numberValue)) ||
					customAttributeRelativeToInvestment.textValue ||
					(customAttributeRelativeToInvestment.dateValue != null &&
						customAttributeRelativeToInvestment.dateValue !== "" &&
						formatDate(customAttributeRelativeToInvestment.dateValue)))) ||
				"-",
		);
	}
}
